var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":"/webroot/images/lifeguard.png","height":"42","width":"42"}}),_vm._v(" "),_c('p',{staticClass:"note-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }